import { render, staticRenderFns } from "./FlagStatusForm.vue?vue&type=template&id=ca973318&"
import script from "./FlagStatusForm.vue?vue&type=script&lang=js&"
export * from "./FlagStatusForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports